import { render, staticRenderFns } from "./ClassTeacherModal.vue?vue&type=template&id=47a3b680&scoped=true"
import script from "./ClassTeacherModal.vue?vue&type=script&lang=js"
export * from "./ClassTeacherModal.vue?vue&type=script&lang=js"
import style0 from "./ClassTeacherModal.vue?vue&type=style&index=0&id=47a3b680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a3b680",
  null
  
)

export default component.exports